import { Component } from '@angular/core';
import { WdxIconLabelComponent } from '@wdx/shared/components/wdx-icon-label';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ColDef, ICellRendererParams } from 'ag-grid-community';

export const ISSUE_COUNT_CELL_RENDERER_COL_DEFS: ColDef = {
    width: 70,
    maxWidth: 80,
};

@Component({
    selector: 'wdx-ag-grid-issues-cell-renderer',

    imports: [WdxIconLabelComponent],
    templateUrl: './issues-count-cell-renderer.component.html',
    host: { class: 'p-2' },
})
export class IssuesCountRendererComponent implements ICellRendererAngularComp {
    public count?: number | null;

    agInit(params: ICellRendererParams<any, number>): void {
        this.count = params?.value;
    }

    refresh(params: ICellRendererParams<any, number>): boolean {
        this.count = params?.value;
        return true;
    }
}
